import classnames from 'classnames';
import { type FC, type ReactElement } from 'react';

import { Carousel } from '@/core/tamagoshi/Carousel/Carousel';
import { Eye as IconEye } from '@/core/tamagoshi/icons/Eye';
import { Text } from '@/core/tamagoshi/Text/Text';
import { isB2B } from '@/domains/core/settings/utils';
import { useMdRankingPlaylistTracking } from '@/domains/productDiscovery/ArticleReviews/modules/mdRankingPlaylist/hooks/useMdRankingPlaylistTracking';
import { RhinoProductCard } from '@/domains/productDiscovery/ProductPage/components/RhinoProductCard/RhinoProductCard';
import { useDetail } from '@/domains/productDiscovery/ProductPage/hooks/useDetail';
import type { RhinoProduct } from '@/domains/productDiscovery/ProductPage/interfaces/RhinoProduct';

import { currentlyViewed } from '../../translations';

import styles from './playlistContent.module.scss';

interface Props {
  products: RhinoProduct[];
  playlistTitle: ReactElement;
  title: string;
}

export const MDRankingPlaylistContent: FC<Props> = ({
  products,
  playlistTitle,
  title,
}) => {
  const { articleId: currentArticleId } = useDetail();

  const { onClick, onDisplay, ref } = useMdRankingPlaylistTracking(title);

  return (
    <div ref={ref} className={styles.container}>
      <Carousel title={playlistTitle} sliderClassName={styles.slider}>
        {products.map((item: RhinoProduct, index: number) => (
          <div className={styles.cardWrapper} key={item.articleId}>
            <div className={styles.cardHeader}>
              <Text
                className={classnames(styles.rank, {
                  [styles.rankCurrent]: item.articleId === currentArticleId,
                })}
              >
                N°{index + 1}
              </Text>
              {item.articleId === currentArticleId && (
                <div className={styles.currentProduct}>
                  <IconEye className={styles.iconEye} height={16} width={16} />
                  <Text className={styles.currentProductText}>
                    {currentlyViewed}
                  </Text>
                </div>
              )}
            </div>
            <RhinoProductCard
              product={item}
              b2b={isB2B()}
              position={index}
              vertical
              light
              className={styles.card}
              onClick={() => onClick(index, item)}
              onDisplay={() => onDisplay(index, item)}
            />
          </div>
        ))}
      </Carousel>
    </div>
  );
};

MDRankingPlaylistContent.displayName = 'MDRankingPlaylistContent';
